<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <div class="row">

                        <div class="col col-12 col-md-6">
                            <h4 class="display-6 text-dark mb-0 text-center">Standard Notice<br /><span class="text-primary">${{FieldInspectionConfig.basicFee.toString().toSmartFixed(2)}}</span></h4>
                            <div class="small text-center mb-5 fw-bold" style="color:darkslategray">(with a {{FieldInspectionConfig.shortNoticeHourThreshold}}+ hour notice)</div>
                        </div>

                        <div class="col col-12 col-md-6">
                            <h4 class="display-6 text-dark mb-0 text-center">Short Notice<br /> <span class="text-primary">${{FieldInspectionConfig.shortNoticeFee.toString().toSmartFixed(2)}}</span></h4>
                            <div class="small text-center mb-5 fw-bold" style="color:darkslategray">(with {{FieldInspectionConfig.minHoursNotice}} to {{FieldInspectionConfig.shortNoticeHourThreshold}} hour notice)</div>
                        </div>

                    </div>
                    <!-- End Row -->
                    <div class="row">

                        <div class="col col-12 text-center">
                            <small class="text-muted fst-italic"><i class="bi bi-info-circle"></i>&nbsp; All prices are per {{FieldInspectionConfig.inspectionDurationMinutes}} minutes of inspection time. Inspections require a minimum {{FieldInspectionConfig.minHoursNotice}} hour notice, even for 'Short Notice' inspections.</small>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'

    export default {
        inheritAttrs: false,
        name: 'InspectionPricing',
        mixins: [ContentBlockBase],
        props: ['fieldinspectionconfig'],
        components: {
        },
        computed:
        {
            FieldInspectionConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.fieldinspectionconfig) {
                    return this.fieldinspectionconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigFieldInspection) {
                    return this.Store.TenantConfig.serviceConfigFieldInspection;
                }
            }
        },
        data() {
            return {  
                AdditionalCfg: 'https://admin.notarylaunchpad.com/home/sitesettings#FieldInspectionSettings'
            };
        },
        methods:
        {
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
          
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
        },
        beforeUnmount()
        {
        },
        mounted() {
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
</style>

